import { googleGeocodingApi } from "../api/googleGeocoding";

function getShortName(components = [], type) {
  const found = components.find((item) => item.types?.includes(type));
  return found?.short_name || "";
}

function buildAddressFromFirstResult(result) {
  const components = result?.address_components || [];

  const route = getShortName(components, "route");
  const locality = getShortName(components, "locality");
  const county = getShortName(components, "administrative_area_level_2");
  const state = getShortName(components, "administrative_area_level_1");
  const postalCode = getShortName(components, "postal_code");
  const country = getShortName(components, "country");

  const cityBlock = [locality, county].filter(Boolean).join(", ");
  const stateZip = [state, postalCode].filter(Boolean).join(" ");

  return [route, cityBlock, stateZip, country].filter(Boolean).join(", ");
}

function toStep2FieldsFromResult(result) {
  const location = result?.geometry?.location || {};

  return {
    property_address: buildAddressFromFirstResult(result),
    latitude:
      location.lat !== undefined && location.lat !== null
        ? String(location.lat)
        : "",
    longitude:
      location.lng !== undefined && location.lng !== null
        ? String(location.lng)
        : "",
    raw: result,
  };
}

export async function fillStep2FromCoordinates(latitude, longitude) {
  const data = await googleGeocodingApi.getAddressByCoordinates(
    latitude,
    longitude,
  );

  if (data?.status !== "OK") {
    throw new Error(
      `Google Geocoding retornou status ${data?.status || "desconhecido"}`,
    );
  }

  const firstResult = data?.results?.[0];

  if (!firstResult) {
    throw new Error("Nenhum endereço encontrado para essas coordenadas");
  }

  return toStep2FieldsFromResult(firstResult);
}

export async function fillStep2FromAddress(address) {
  const data = await googleGeocodingApi.getCoordinatesByAddress(address);

  if (data?.status !== "OK") {
    throw new Error(
      `Google Geocoding retornou status ${data?.status || "desconhecido"}`,
    );
  }

  const firstResult = data?.results?.[0];

  if (!firstResult) {
    throw new Error("Nenhuma coordenada encontrada para esse endereço");
  }

  return toStep2FieldsFromResult(firstResult);
}